<style lang="less" scoped>
  #detail {
    .order-cancel-btn {
      border: none;
      background: none;
      color: #7ed321;
    }

    .profile-page-content {
      margin-bottom: 32px;
      position: relative;
    }

    .mobile-delete-cover {
      text-align: right;
      position: absolute;
      padding-top: 8px;
      width: 100%;
      display: none;

      .mobile-delete-btn {
        border: none;
        padding: 0;
        font-size: 14px;
        color: #7ed321;
      }
    }

    .present-list-cover {
      margin: 0 -16px;

      &:after {
        content: "";
        display: block;
        clear: both;
      }
    }
  }

  @media screen and (max-width: 560px) {
    #detail {
      .mobile-delete-cover {
        display: block;
      }
    }
  }
</style>

<template lang="pug">
  #detail(v-loading="isLoading")
    .area-container.area-container-mobile
      .page-title-area
        h1 {{title}}
        .nav-area
          router-link(to="#")
            el-button.order-cancel-btn(@click="cancelOrder" v-if="status === 'paid'") 주문취소
      .profile-page-content
        .mobile-delete-cover
          el-button.mobile-delete-btn(
            @click="cancelOrder",
            v-if="status === 'paid'",
            type="default") 주문취소
        profile-component(
          v-if='order',
          :order="order")
      .present-list-cover
        present-card-component(
          v-for="prescription in prescriptions",
          :prescription="prescription")
</template>

<script>
import presentCardComponent from '@/components/present_card';
import profileComponent from '@/components/profile';
import Happytree from '@/happytree';
import moment from 'moment';

moment.locale('ko');

export default {
  async mounted() {
    this.isLoading = true;
    this.$store.commit('setTitle', this.title);

    const objectId = this.$route.params.orderId;
    try {
    // 익셉션 반환 필요
      const { data } = await this.$http.get('/orders/'.concat(objectId));
      this.order = data;

      this.status = data.status;
      this.prescriptions = JSON.parse(JSON.stringify(this.order.prescriptions));
      this.isLoading = false;
    } catch (e) {
      alert('데이터를 불러오지 못했습니다.');
      this.$router.push('/mylist');
    }
  },
  props: {
    title: {
      type: String,
    },
  },
  methods: {
    async cancelOrder() {
      if (confirm('정말로 주문을 취소하시겠습니까?')) {
        const objectId = this.$route.params.orderId;
        const payload = {
          status: Happytree.status.canceled,
        };
        try {
          await this.$http.put('/orders/'.concat(objectId), payload);
          alert('주문을 취소했습니다.');
          this.$router.replace('/mylist');
        } catch (e) {
          alert('주문을 취소하지 못했습니다.');
        }
      }
    },
  },
  data() {
    return {
      status: 1,
      order: null,
      sender: {},
      prescriptions: [],
      isLoading: false,
    };
  },
  components: {
    presentCardComponent,
    profileComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/index/detail.vue